export * from './delete-kunden-gruppe.command.module';
export * from './service';
export * from './component';